export const SET_ADAPTER_TAG = 'set-adapted-tag'
export const SET_ADAPTED_PARAMS = 'set-adapted-params'
